var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 320,
    viewBox: "0 0 640 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 235.764H249.116L273.437 85.7197H312.318L288 235.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.955 89.388C421.286 86.352 409.121 83 394.08 83C355.681 83 328.641 103.43 328.475 132.64C328.156 154.191 347.835 166.16 362.553 173.346C377.597 180.689 382.711 185.481 382.711 192.026C382.557 202.078 370.555 206.712 359.36 206.712C343.836 206.712 335.518 204.323 322.877 198.73L317.757 196.333L312.316 230.015C321.435 234.16 338.237 237.839 355.681 238C396.48 238 423.042 217.886 423.357 186.758C423.512 169.678 413.121 156.59 390.718 145.895C377.118 139.03 368.79 134.401 368.79 127.376C368.949 120.991 375.834 114.45 391.186 114.45C403.827 114.129 413.114 117.161 420.15 120.195L423.667 121.788L428.955 89.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.635 182.609C483.837 173.989 496.159 140.627 496.159 140.627C495.997 140.948 499.354 131.848 501.274 126.262L503.992 139.191C503.992 139.191 511.355 175.107 512.954 182.609C506.877 182.609 488.315 182.609 480.635 182.609ZM528.631 85.7197H498.555C489.28 85.7197 482.234 88.4311 478.232 98.169L420.476 235.762H461.275C461.275 235.762 467.992 217.243 469.435 213.254C473.911 213.254 513.6 213.254 519.358 213.254C520.475 218.522 523.998 235.762 523.998 235.762H560L528.631 85.7197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.639 85.7197L178.56 188.035L174.398 167.285C167.358 143.341 145.279 117.326 120.64 104.391L155.519 235.605H196.637L257.755 85.7197H216.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2 85.7197H80.64L80 88.7514C128.8 101.203 161.12 131.216 174.399 167.291L160.799 98.3323C158.56 88.7493 151.679 86.0358 143.2 85.7197Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 155,
    fill: "white",
    transform: "translate(80 83)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/va.47f01cee2c523357ffb31d5fa43d6b69.svg";
export { ForwardRef as ReactComponent };